var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.validAsset)?_c('h2',[_vm._v("\n    "+_vm._s(_vm.asset.title)+"\n  ")]):_c('h2',[_vm._v("\n    Loading..\n  ")]),(_vm.hasData)?_c('RawViewer',{attrs:{"sequence":_vm.sequence,"resources":_vm.resources}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }